<template>
  <div class="home">
    <section id="hero">
      <v-row no-gutters>
        <v-img
          :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          src="img/neumaticoslasdelicias_.jpeg"
        >
          <v-theme-provider
            dark
            style="
              background-image: linear-gradient(
                to right,
                rgba(5, 11, 31, 0.6),
                rgba(5, 11, 31, 0.6)
              );
            "
          >
            <v-container
              fill-height
              class="pa-0"
              fluid
            >
              <v-row
                align="center"
                class="white--text mx-auto"
                justify="center"
              >
                <v-col
                  class="white--text text-center"
                  cols="12"
                  tag="h1"
                >
                  <span
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
                    ]"
                    class="font-weight-light"
                  >PIDE</span>

                  <br />

                  <span
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-2' : 'display-4',
                    ]"
                    class="font-weight-black white--text"
                  >PRESUPUESTO</span>
                </v-col>

                <v-btn
                  class="align-self-end"
                  fab
                  outlined
                  @click="$vuetify.goTo('#presupuesto')"
                >
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>
    <section
      id="features"
      class="grey lighten-3"
    >
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">INFORMACIÓN</h2>
        <v-responsive
          class="mx-auto mb-12"
          width="56"
        >
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-card
              class="py-12 px-4"
              color="grey lighten-5"
              flat
            >
              <v-theme-provider dark>
                <div>
                  <v-avatar
                    color="primary"
                    size="88"
                  >
                    <v-icon large>mdi-clock</v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>
              <v-card-title class="justify-center font-weight-black text-uppercase">HORARIO</v-card-title>
              <v-card-text class="subtitle-1">
                <h4>LUNES A VIERNES</h4>
                <p class="mb-0">9:00 - 14:00<br />16:00 - 19:00</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-card
              class="py-12 px-4"
              color="grey lighten-5"
              flat
            >
              <v-theme-provider dark>
                <div>
                  <v-avatar
                    color="primary"
                    size="88"
                  >
                    <v-icon large>mdi-beach</v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>
              <v-card-title class="justify-center font-weight-black text-uppercase">VACACIONES</v-card-title>
              <v-card-text class="subtitle-1">
                <h4>
                  SEMANA SANTA Y SEMANA DE FERIA PERMANECEREMOS CERRADOS POR
                  DESCANSO DEL PERSONAL. DISCULPEN LAS MOLESTIAS.
                </h4>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
            id="presupuesto"
          >
            <v-card class="ma-2 pa-0">
              <v-row class="grey darken-3 pa-0 ml-0 mr-3">
                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <v-card-title
                    col="12"
                    class="white--text pa-0"
                  >
                    <v-row class="ml-2">
                      <v-col
                        class="d-flex align-center"
                        cols="8"
                        md="9"
                        :class="[
                          $vuetify.breakpoint.xs ? 'subtitle-1' : 'title',
                        ]"
                      >Solicita presupuesto</v-col>

                      <v-col
                        cols="4"
                        md="3"
                        class="align-stretch text-center primary subtitle-1 pa-0 fill-height"
                      >
                        <v-row
                          justify="center"
                          class="fill-height py-4"
                        >¡Es gratis!</v-row>
                      </v-col>
                    </v-row>
                  </v-card-title>
                </v-col>
              </v-row>
              <v-card-text class>
                <v-form class="ma-1">
                  <v-text-field
                    v-model="contacto.nombre"
                    label="Nombre"
                    :error-messages="nombreErrors"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="contacto.email"
                    label="Email"
                    :error-messages="emailErrors"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="contacto.telefono"
                    label="Telefono"
                    :error-messages="telefonoErrors"
                    outlined
                    required
                  ></v-text-field>
                  <v-textarea
                    v-model="contacto.consulta"
                    single-line
                    label="Consulta"
                    :error-messages="consultaErrors"
                    outlined
                    required
                  ></v-textarea>
                  <v-row
                    justify="center"
                    class="mr-4"
                  >
                    <v-btn
                      id="botonEnviar"
                      color="primary"
                      rounded
                      :loading="loading"
                      @click="sendEmail"
                    >Solicitar presupuesto</v-btn>
                  </v-row>
                  <v-alert
                    v-if="mostrarAlerta"
                    class="green lighten-3 black--text mt-3 msjEnviado"
                    big
                  >Gracias por su mensaje. Nos pondremos en contacto con usted
                    lo antes posible</v-alert>
                  <v-row
                    justify="center"
                    class="caption text--primary"
                  >
                    <div class="red--text text--darken-4 mt-3">
                      Gratis y sin compromiso
                    </div>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>
    <section
      class="grey lighten-2"
      id="donde"
    >
      <v-container
        fluid
        class="grey lighten-2"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <h6 class="display-1 font-weight-bold mb-3 text-center">NAVE</h6>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6398.307652936922!2d-4.451189920408009!3d36.6948412698816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa517ffdca168541!2sNeumaticos%20las%20delicias!5e0!3m2!1ses!2ses!4v1593410681995!5m2!1ses!2ses"
              width="100%"
              height="450"
              frameborder="0"
              style="border: 0"
              allowfullscreen
              aria-hidden="false"
              tabindex="0"
            ></iframe>
            <v-card class="pa-4">
              <v-row justify="center">
                <v-card-title class="title mb-3 text-no-wrap">¿Prefieres una cita personal?</v-card-title>
                <v-card-text class="body-1 text-justify">
                  Llámanos o escríbenos para concertar una cita en nuestras
                  instalaciones de Calle Calañas.
                  <v-row
                    class="mt-3"
                    align="center"
                    justify="start"
                    no-gutters
                  >
                    <v-col
                      cols="12"
                      md="4"
                      class="pr-1"
                    >
                      <v-icon class="mr-4">mdi-phone</v-icon>
                      <a
                        id="botonTelefono"
                        class="nolink"
                        href="tel://952320023"
                      >952 320 023 / 682 242 203</a>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-icon class="mr-4">mdi-email</v-icon>
                      <a
                        class="primary--text"
                        style="text-decoration: none"
                        href="mailto:neumaticos_las_delicias@hotmail.com"
                      >neumaticos_las_delicias@hotmail.com</a>
                    </v-col>
                  </v-row>

                  <v-row
                    class
                    align="center"
                    justify="start"
                  >
                    <v-col cols="12">
                      <v-icon class="mr-4">mdi-map-marker</v-icon>
                      <span class="text-wrap">Calle Calañas 9, Málaga</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-row>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-if="false"
          >
            <h6 class="display-1 font-weight-bold mb-3 text-center">TALLER</h6>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6074.131090853957!2d-4.449588039542201!3d36.69549998183611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf365200f6249556e!2sNeumaticos%20Las%20Delicias!5e0!3m2!1ses!2ses!4v1593410725155!5m2!1ses!2ses"
              width="100%"
              height="450"
              frameborder="0"
              style="border: 0"
              allowfullscreen
              aria-hidden="false"
              tabindex="0"
            ></iframe>
            <v-card class="pa-4">
              <v-row justify="center">
                <v-card-title class="title mb-3 text-no-wrap">¿Prefieres una cita personal?</v-card-title>
                <v-card-text class="body-1 text-justify">
                  Llámanos o escríbenos para concertar una cita en nuestras
                  instalaciones de Avenida Sor Teresa Prat
                  <v-row
                    class="mt-3"
                    align="center"
                    justify="start"
                    no-gutters
                  >
                    <v-col
                      cols="12"
                      md="4"
                      class="pr-1"
                    >
                      <v-icon class="mr-4">mdi-phone</v-icon>
                      <a
                        id="botonTelefono"
                        class="nolink"
                        href="tel://952313535"
                      >952 31 35 35</a>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-icon class="mr-4">mdi-email</v-icon>
                      <a
                        class="primary--text"
                        style="text-decoration: none"
                        href="mailto:neumaticos_las_delicias@hotmail.com"
                      >neumaticos_las_delicias@hotmail.com</a>
                    </v-col>
                  </v-row>

                  <v-row
                    class
                    align="center"
                    justify="start"
                  >
                    <v-col cols="12">
                      <v-icon class="mr-4">mdi-map-marker</v-icon>
                      <span class="text-wrap">Avenida Sor Teresa Prat 54, Málaga</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'Home',
  validations: {
    contacto: {
      nombre: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
      },
      telefono: {
        required,
        minLength: minLength(9),
      },
      consulta: {
        required,
        minLength: minLength(9),
      },
    },
  },
  data() {
    return {
      loading: false,
      mostrarAlerta: false,
      contacto: {
        nombre: '',
        email: '',
        telefono: '',
        consulta: '',
      },
    };
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.contacto.nombre.$dirty) return errors;
      !this.$v.contacto.nombre.minLength &&
        errors.push('Nombre demasiado corto.');
      !this.$v.contacto.nombre.required && errors.push('Nombre obligatorio.');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.contacto.email.$dirty) return errors;
      !this.$v.contacto.email.required && errors.push('Email obligatorio.');
      !this.$v.contacto.email.email && errors.push('Email incorrecto.');
      return errors;
    },
    msjErrors() {
      const errors = [];
      if (!this.$v.contacto.msj.$dirty) return errors;
      !this.$v.contacto.msj.minLength &&
        errors.push('Mensaje demasiado corto.');
      !this.$v.contacto.msj.required && errors.push('Mensaje requerido.');
      return errors;
    },
    telefonoErrors() {
      const errors = [];
      if (!this.$v.contacto.telefono.$dirty) return errors;
      !this.$v.contacto.telefono.minLength &&
        errors.push('Telefono demasiado corto.');
      !this.$v.contacto.telefono.required &&
        errors.push('Telefono requerido.');
      return errors;
    },
    consultaErrors() {
      const errors = [];
      if (!this.$v.contacto.consulta.$dirty) return errors;
      !this.$v.contacto.consulta.minLength &&
        errors.push('Mensaje demasiado corto.');
      !this.$v.contacto.consulta.required &&
        errors.push('Mensaje requerido.');
      return errors;
    },
  },
  methods: {
    sendEmail() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        /*this.$gtag.reportConversion({
        send_to: "AW-1032001574/JhO7CIC_884BEKawjOwD" // the custom tag to be reported
      });*/
        const _vm = this;
        _vm.loading = true;
        this.contacto.asunto = 'Mensaje desde la web';

        this.$store
          .dispatch('sendEmail', this.contacto)
          .then(() => {
            this.mostrarAlerta = true;
            this.contacto = {
              nombre: '',
              email: '',
              consulta: '',
              telefono: '',
            };
            this.$v.$reset();
          })
          .catch((e) => {
            console.log(e);
            this.$store.commit(
              'setSnackError',
              'Error al enviar el mensaje. ' + e
            );
          })
          .finally(() => (_vm.loading = false));
      }
    },
  },
  mounted() { },
};
</script>
